import {
  EinvoicingNudgeModal,
  GoogleModal,
  PaymentModals,
  usePaymentStatus,
  useSubscriptionStatus,
} from "@mytour/company-settings";
import {CguGate, OnboardingWelcomeModal} from "@mytour/onboarding";
import {
  useAccount,
  useCurrentCompany,
  useGoogleInfo,
  useModeration,
  useOnboardingStatus,
} from "@mytour/platform";
import {useState} from "react";
import {useLocation} from "react-router";

export function AppModals() {
  const {account} = useAccount();
  const {company} = useCurrentCompany();
  const {subscription, isSubscriptionLoading} = useSubscriptionStatus(company?.id);
  const {paymentStatus, isPaymentStatusLoading} = usePaymentStatus(
    subscription?.paymentNeeded === true,
    company?.id
  );
  const {googleInfo} = useGoogleInfo();
  const {isModeration} = useModeration();
  const {status} = useOnboardingStatus();
  const location = useLocation();
  const [dismissedPaymentId, setDismissedPaymentId] = useState<string | null>(null);

  if (!account) {
    return null;
  }
  if (location.pathname === "/google/auth") {
    return null; // login with google
  }
  if (!company) {
    return null;
  }
  return (
    <CguGate key={account.id} account={account}>
      {renderOtherModals()}
    </CguGate>
  );

  function renderOtherModals() {
    if (!company) {
      return null;
    }
    // Le statut paiement se résout en deux requêtes chaînées (`isPaymentStatusLoading` ne
    // démarre qu'une fois `subscription` connu) — sans ce guard, la fenêtre entre les deux
    // laisse tomber sur les modales suivantes (nudge e-facture incluse) alors que
    // `paymentNeeded` est vrai mais pas encore confirmé bloquant, avec leurs propres effets
    // de bord (#650 : POST nudge-seen + event PostHog émis pour une modale jamais montrée).
    if (isSubscriptionLoading || (subscription?.paymentNeeded && isPaymentStatusLoading)) {
      return null;
    }
    const paymentDismissed =
      paymentStatus &&
      !paymentStatus.blocking &&
      dismissedPaymentId === paymentStatus.existingOrderId;
    if (subscription?.paymentNeeded && paymentStatus && !paymentDismissed) {
      return (
        <PaymentModals
          paymentStatus={paymentStatus}
          onDismiss={() => setDismissedPaymentId(paymentStatus.existingOrderId)}
        />
      );
    }
    if (status !== "FINISHED") {
      return <OnboardingWelcomeModal company={company} />;
    }
    const isGoogleAuthenticated =
      googleInfo?.hasCredentials ||
      account?.login === "e2e" ||
      account?.login === "e2e2"; /* don't block e2e with google stuff*/
    if (company.features.synchronizeAgenda && !isModeration && !isGoogleAuthenticated) {
      return <GoogleModal />;
    }
    // Dernière priorité du cascade (#650) : ne s'affiche que si aucune autre
    // modale bloquante n'occupe le login. Volontairement visible en session
    // modération, contrairement à Google ci-dessus : le nudge doit rester
    // observable en connexion impersonation pour le dogfooding/support.
    return <EinvoicingNudgeModal />;
  }
}
